<template>

  <el-dialog title="관리자 메모" 
    :visible.sync="value" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false" 
    :show-close="false"
    @open="dialogOpen">
    <el-form :model="form" ref="form">
      <el-form-item 
        label="관리자 이름" 
        prop="manager"
        :label-width="'120px'"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-input v-model="form.manager" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item 
        label="타입" 
        prop="type"
        :label-width="'120px'"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-select v-model="form.type" placeholder="타입을 선택해 주세요">
          <el-option v-for="type in $service.memoType" :key="type" :label="type" :value="type"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item 
        label="메모" 
        prop="memo"
        :label-width="'120px'"
        :rules="[
          { required: true, message: '필수 항목 입니다.'}
        ]">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="메모를 입력해 주세요"
          v-model="form.memo">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">취소</el-button>
      <el-button type="primary" @click="submitForm">확인</el-button>
    </span>
  </el-dialog>

</template>

<script>
export default {
  props: ['value'],
  methods: {
    async dialogOpen () {
      let adminName = await this.$service.localdb.getItem('admin_name')
      this.form.manager = adminName || ''
    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            manager: this.form.manager,
            type: this.form.type,
            memo: this.form.memo
          }
          this.$emit('close', params)
          this.$refs.form.resetFields()
        }
      });
    },
    close () {
      this.$emit('close')
      this.$refs.form.resetFields()
    }
  },
  data () {
    return {
      form: {
        manager: '',
        type: '',
        memo: ''
      }
    }
  }
}
</script>
